var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorbellChime01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.05,12.19H5.68V3.82h8.37V12.19z M6.18,11.69h7.37V4.32H6.18V11.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.95,
    y: 4.06,
    className: "st2",
    width: 0.5,
    height: 7.87
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.2,
    y: 7.75,
    className: "st2",
    width: 3.76,
    height: 0.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.41,9.38V6.6h1.04c0.21,0,0.38,0.03,0.51,0.08c0.13,0.06,0.23,0.14,0.3,0.26c0.07,0.12,0.11,0.24,0.11,0.37 c0,0.12-0.03,0.23-0.1,0.34C9.22,7.75,9.12,7.83,8.99,7.9c0.17,0.05,0.3,0.13,0.39,0.25c0.09,0.12,0.14,0.26,0.14,0.42 c0,0.13-0.03,0.25-0.08,0.36s-0.12,0.2-0.2,0.26C9.14,9.26,9.04,9.3,8.92,9.33C8.8,9.36,8.65,9.38,8.47,9.38H7.41z M7.78,7.77h0.6 c0.16,0,0.28-0.01,0.35-0.03C8.83,7.71,8.9,7.66,8.94,7.59c0.05-0.06,0.07-0.15,0.07-0.24c0-0.09-0.02-0.17-0.07-0.24 C8.9,7.04,8.84,6.99,8.76,6.96C8.68,6.94,8.54,6.92,8.33,6.92H7.78V7.77z M7.78,9.05h0.69c0.12,0,0.2,0,0.25-0.01 C8.81,9.02,8.88,9,8.94,8.96c0.06-0.04,0.1-0.09,0.14-0.15c0.04-0.07,0.06-0.15,0.06-0.23c0-0.1-0.03-0.19-0.08-0.27 C9,8.22,8.92,8.17,8.83,8.14C8.74,8.11,8.6,8.09,8.42,8.09H7.78V9.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.23,9.38V6.92h-0.92V6.6h2.21v0.33h-0.92v2.46H11.23z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorbellChime01);
export default __webpack_public_path__ + "static/media/DoorbellChime-01.a2c369aae7f7aadca5f598ec83fe2734.svg";
export { ForwardRef as ReactComponent };